// extracted by mini-css-extract-plugin
module.exports =  {"button":"_2787e5dfdf--button--GVLSF","dark":"_2787e5dfdf--dark--gen_X"};